export enum StatusIconDefaults {
  valid = "check-circle",
  invalid = "exclamation-mark-triangle",
  idle = "information",
}
